<nz-space class="mobile-report-control">
  <app-ap-cate-select [showAddNewButton]="false" [(ngModel)]="from" class="report-control"
    (ngModelChange)="fromChange.emit($event)" valueField="code">
  </app-ap-cate-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-ap-cate-select [showAddNewButton]="false" [(ngModel)]="to" class="report-control"
    (ngModelChange)="toChange.emit($event)" valueField="code">
  </app-ap-cate-select>
</nz-space>